<template>
	<div>
    <div class="p-3 md:p-5 border rounded-lg border-dark-b">
      <div class="flex items-center justify-between pb-2 border-b border-dark-b">
        <p class="text-xl font-semibold">
          Best Seller Items
        </p>
        <div class="flex">
          <div
            class="rounded-full bg-smoke-100 w-10 h-10 opacity-50 cursor-pointer flex items-center mr-3"
            @click="slideProduct(-1)"
          >
            <img src="@/assets/icons/chevronLeft.svg" class="mx-auto">
          </div>
          <div
            class="rounded-full bg-smoke-100 w-10 h-10 opacity-50 cursor-pointer flex items-center"
            @click="slideProduct(1)"
          >
            <img src="@/assets/icons/chevronRight.svg" class="mx-auto">
          </div>
        </div>
      </div>
      <div v-if="mainProducts.length" class="pt-8">
        <ItemsCarousel
          :items="3"
          :dots="false"
          ref="productCarousel"
        >
          <div
            v-for="(product, index) in mainProducts"
            :key="`supplier-main-product-${index}`"
            class="pl-1 py-1"
          >
            <ProductPreview :product="product" />
          </div>
        </ItemsCarousel>
      </div>
      <div v-else class="text-center py-6">
        No Product
      </div>
    </div>
    <div class="p-3 md:p-5 border rounded-lg border-dark-b mt-10">
      <div class="pb-2 border-b border-dark-b">
        <p class="text-xl font-semibold">
          All Products
          <span class="text-sm font-normal">({{products.length}} Products Found)</span>
        </p>
      </div>
      <div class="py-7.5 grid grid-cols-2 lg:grid-cols-3 gap-4 xl:gap-10">
        <ProductPreview
          v-for="(product, index) in products"
          :key="`supplier-product-${index}`"
          :product="product"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ItemsCarousel from '@/shared/components/shared/ItemsCarousel'
import ProductPreview from '@/shared/components/product/ProductPreview'

export default {
	name: 'ProductsDetailTab',
	props: {
		mainProducts: {
			type: Array,
			required: true
		},
		products: {
			type: Array,
			required: true
		}
	},
	components: {
		ItemsCarousel,
		ProductPreview
	},
	methods: {
		slideProduct(val) {
			const navs = this.$refs.productCarousel.$el.querySelectorAll('.owl-nav')
      navs.forEach(nav => {
        val === 1 ? nav.lastChild.click() : nav.firstChild.click()
      })
		}
	}
}
</script>
